import { PopupRepository } from '../infrastructure/repositories/popup.repository';
import { Router } from '@angular/router';
import { Observable} from 'rxjs';
import { EventEmitter, Injectable } from '@angular/core';
import { SleekNoteMessage } from '../model/interfaces/sleeknote-message';

@Injectable({
    providedIn: 'root'
})
export class PopupService
{
    public readonly onCta = new EventEmitter();
    private readonly repository: PopupRepository;
    private readonly router: Router;

    public constructor(repository: PopupRepository, router: Router)
    {
        this.repository = repository;
        this.router = router;
    }

    public getPopUpMessage() : Observable<SleekNoteMessage[]>
    {
        return this.repository.getPopupMessage();
    }
    
    public triggerMessageCta(message: SleekNoteMessage): void
    {
        switch(message.CtaType)
        {
            case 'route' : 
                this.router.navigate([message.Cta]);
                break;
            case 'external-url' : 
                window.location.href = message.Cta;
                break;
            case 'event' :
                this.onCta.emit(message.Cta);
                break;
        }
    }
}